import React, {useCallback, useMemo} from 'react'
import loadable from '@loadable/component'
import {
    useLeapDrawer,
    useIsLeapDrawerOpen,
    preloadLeapDrawer
} from '../../../../leap/components/drawer'

const QuickviewBody = loadable(() => import('./internal'))

export const preloadQuickview = () => Promise.all([preloadLeapDrawer(), QuickviewBody.preload()])

export const useIsQuickviewOpen = useIsLeapDrawerOpen

export const useQuickview = (itemId) => {
    const {open: openDrawer, close, remove} = useLeapDrawer(itemId)

    const open = useCallback(
        ({onClose, ...contentProps}) =>
            openDrawer({content: <QuickviewBody {...contentProps} />, onClose}),
        [openDrawer]
    )

    return useMemo(() => ({open, close, remove}), [open, close, remove])
}
